import React from "react";
import { withRouter } from "react-router-dom";
import { BackTop } from 'antd';

const style = {
  backgroundColor: "#065db1",
  cursor: "pointer",
  textAlign: 'center',
  lineHeight: '35px',
  height: "35px",
  width: "35px",
  borderRadius: "2px"
};

class ScrollToTop extends React.Component {
  componentDidUpdate(prevProps) {
    if (
      this.props.location.pathname !== prevProps.location.pathname
    ) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    return (
      <BackTop visibilityHeight={50} style={{right: 20, bottom: 25, opacity: .9}} >
        <div  style={style}>
          <i className="fa fa-chevron-up fa-lg" style={{color: "#fff"}}/>
        </div>
      </BackTop>
    );
  }
}

export default withRouter(ScrollToTop);
